import $ from 'jquery';

// Sur mobile, au scroll, le menu du navigateur disparait ce qui trgger un resize qui n'en est pas un.
// Donc on check que c'est bien la largeur qui est modifiée
var widthOfScreen = $(window).width();

function setAsideMenu() {
    var $menuInAside = $('#menuInAside:not(.menuInAsideCompte)');
    var $menuInAsideCompte = $('.menuInAsideCompte');

    if ((window.matchMedia('(min-width: 992px)').matches)) {
        $menuInAside.addClass('in');
    }
    else {
        $menuInAside.removeClass('in');
    }

    if ((window.matchMedia('(min-width: 1300px)').matches)) {
        $menuInAsideCompte.addClass('in');
    }
    else {
        $menuInAsideCompte.removeClass('in');
    }
}

$(document).ready(function () {
    setAsideMenu();
});

$(window).resize(function () {
    if ($(window).width() != widthOfScreen) {
        setAsideMenu();
        widthOfScreen = $(window).width();
    }

});
